module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/user-secret-55c8debaabcf2ca42888cd294c62a394.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/user-secret.svg
// module id = dVYe
// module chunks = 24